import Typography from 'components/Typography';
import PageHeader from 'components/PageHeader';
import ListWrapper from 'components/ListWrapper';
import FormGroup from 'components/FormGroup';
import TextField from 'components/TextField';
import Button from 'components/Button';
import {validateEmail} from 'utils/validators';
import {GooglePlaceAutoComplete} from 'components/GooglePlaceAutoComplete';
import {addressToString} from 'helpers/address';
import ConfirmationModal from 'pages/Signup/ConfirmationModal';
import useCompanyDetails from './useCompanyDetails';
import {phoneFormat} from 'helpers/phoneFormat';
import ListTabs from './ListTabs';
import PropertyList from './PropertyList';
import styles from './CompanyDetails.module.scss';
import {COMPANY_TYPE_OPTIONS_LABELS} from 'constants/select-options';
import {useCompanyConfig} from 'hooks/useCompanyConfig';
import {useMemo} from 'react';
import Notifications from './Notifications';

function CompanyDetails() {
  const {
    refetch,
    properties,
    status,
    setStatus,
    currentUser,
    confirmationVisible,
    setConfirmationVisible,
    loading,
    register,
    setValue,
    errors,
    getValues,
    handleCheckChanges,
    confirmHandler,
    sendConfirmation,
  } = useCompanyDetails();
  const {labels, hasFeature} = useCompanyConfig();
  const tabs = useMemo(() => {
    return hasFeature('hasManagedPropertiesOnCompanyDetails')
      ? [
          {title: 'Details', value: ''},
          {
            title: labels.properties,
            value: 'properties',
          },
          {title: 'Notifications', value: 'notifications'},
        ]
      : [
          {title: 'Details', value: ''},
          {title: 'Notifications', value: 'notifications'},
        ];
  }, [labels.properties, hasFeature]);

  return (
    <div>
      <PageHeader style={{height: 50}}>
        <Typography variant="h2">Company</Typography>
      </PageHeader>
      <ListTabs onChange={setStatus} activeTabValue={status} tabs={tabs} />
      <FormGroup style={{marginBottom: 20}} columns={2}>
        {status === '' && (
          <ListWrapper className={styles.list}>
            <div>
              <FormGroup>
                <TextField
                  label="Company Name"
                  placeholder="Name"
                  {...register('name', {
                    required: 'Required',
                  })}
                  error={errors.name?.message}
                />
              </FormGroup>
              <TextField
                label="Company Type"
                placeholder=""
                value={COMPANY_TYPE_OPTIONS_LABELS[currentUser?.company?.type!]}
                defaultValue={
                  COMPANY_TYPE_OPTIONS_LABELS[currentUser?.company?.type!]
                }
                disabled
              />
              <FormGroup>
                <TextField
                  label="Company Email"
                  placeholder="Email"
                  {...register('email', {
                    validate: validateEmail,
                    required: 'Required',
                  })}
                  error={errors.email?.message}
                />
              </FormGroup>

              <FormGroup columns={1}>
                <GooglePlaceAutoComplete
                  label="Company Address"
                  placeholder="Address"
                  defaultValue={getValues().address}
                  onPlaceSelected={(data) => {
                    setValue(
                      'address',
                      addressToString({
                        address_line_1: data.addressLine1,
                        city: data.city,
                        state: data.state,
                        zipcode: data.zipcode,
                        address_line_2: '',
                        is_primary: false,
                        is_valid: true,
                        label: '',
                        latitude: data.lat,
                        longitude: data.lon,
                        unit_address: '',
                        id: 0,
                        type: 'billing',
                      })
                    );
                  }}
                  error={errors?.address?.message}
                  options={{
                    types: ['address'],
                  }}
                />
              </FormGroup>

              <FormGroup columns={1}>
                <TextField
                  label="Company Phone"
                  placeholder="(123) 456-7890"
                  {...register('phone', {
                    required: 'Required',
                    minLength: {
                      value: 14,
                      message: 'Enter a valid phone number',
                    },
                  })}
                  type="tel"
                  onChange={(e) => {
                    let input = e.target.value.replace(/\D/g, ''); // Faqat raqamlarni qoldirish

                    e.target.value = phoneFormat(input);
                    // e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                  error={errors.phone?.message}
                />
              </FormGroup>
              <FormGroup columns={1}>
                <TextField
                  label="Company Website"
                  placeholder="https://"
                  {...register('website')}
                  error={errors.website?.message}
                />
              </FormGroup>
              <FormGroup columns={1}>
                <TextField
                  label="Support Phone"
                  placeholder="(123) 456-7890"
                  {...register('support_phone', {})}
                  type="tel"
                  onChange={(e) => {
                    let input = e.target.value.replace(/\D/g, ''); // Faqat raqamlarni qoldirish

                    e.target.value = phoneFormat(input);
                  }}
                  error={errors.support_phone?.message}
                />
              </FormGroup>
            </div>
            <Button
              loading={loading}
              onClick={handleCheckChanges}
              className={styles.save}
            >
              Save
            </Button>
          </ListWrapper>
        )}
        {status === 'properties' && (
          <PropertyList
            properties={properties}
            refetch={refetch}
            isShow={status === 'properties'}
          />
        )}
        {status === 'notifications' && <Notifications />}
      </FormGroup>

      <ConfirmationModal
        confirmationVisible={confirmationVisible}
        onClose={() => setConfirmationVisible(false)}
        confirmHandler={confirmHandler}
        email={getValues('email')}
        resendCode={sendConfirmation}
      />
    </div>
  );
}

export default CompanyDetails;
